import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import styled from "@mui/material/styles/styled";
import { FlexBetween } from "src/lib/components/salify-next-layout/default/components/flex-box";
import { keyframes } from "@mui/material/styles";

export const StyledChip = styled(Chip)(({ theme }) => ({
  zIndex: 1,
  top: "10px",
  left: "10px",
  paddingLeft: 3,
  paddingRight: 3,
  fontWeight: 600,
  fontSize: "10px",
  position: "absolute",
  color: theme.palette.common.white,
  background: theme.palette.primary.main,
})); // ==============================================================

export const StyledCard = styled(Box)(({ theme }) => ({
  height: "100%",
  margin: "auto",
  borderRadius: "1rem",
  overflow: "hidden",
  position: "relative",
  transition: "all 250ms ease-in-out",
  "&:hover": {
    boxShadow: theme.shadows[2],
    "& .controlBox": {
      display: "flex",
      bottom: 0,
    },
  },
  display: "flex",
  flexDirection: "column",
}));
export const ImgBox = styled("div", { shouldForwardProp: (props) => props !== "bgColor" })(
  ({ theme, bgColor }) => ({
    overflow: "hidden",
    position: "relative",
    padding: "20px 40px",
    background: bgColor || theme.palette.warning[50],
  }),
);
const huerotate = keyframes`
  0% {
    filter: hue-rotate(0deg);
  }
  100% {
    filter: hue-rotate(360deg);
  }
`;
export const FeatureImgBox = styled("div", { shouldForwardProp: (props) => props !== "bgColor" })(
  ({ theme, bgColor }) => ({
    margin: "auto",
    border: "10px solid",
    borderImage: "linear-gradient(45deg, gold, deeppink) 1",
    clipPath: "inset(0px round 10px)",
    animation: `${huerotate} 6s infinite linear`,
    filter: "hue-rotate(360deg)",
    overflow: "hidden",
    position: "relative",
    padding: "10px 30px",
    background: bgColor || theme.palette.warning[50],
  }),
);

export const ItemController = styled(FlexBetween)(({ theme }) => ({
  width: 35,
  right: 15,
  height: 120,
  bottom: -120,
  background: "#fff",
  overflow: "hidden",
  position: "absolute",
  flexDirection: "column",
  transition: "bottom 0.3s ease-in-out",
  "& span": {
    width: "100%",
    height: "100%",
    display: "flex",
    padding: "8px 10px",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      cursor: "pointer",
      background: theme.palette.primary.main,
      "& svg": {
        color: "#fff",
      },
    },
  },
  "& svg": {
    fontSize: 18,
    color: theme.palette.grey[600],
  },
}));
export const ContentWrapper = styled("div")({
  flex: 1,
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  padding: "1rem",
  "& .title": {
    flex: "1 0 auto",
    margin: 0,
  },
});
